export const viewTitle = "Управленческие документы";
export const viewUniqKey = "doc-type";
